import { render, staticRenderFns } from "./OrdenDeSalida.vue?vue&type=template&id=cabfe25a&scoped=true"
import script from "./OrdenDeSalida.vue?vue&type=script&lang=js"
export * from "./OrdenDeSalida.vue?vue&type=script&lang=js"
import style0 from "./OrdenDeSalida.vue?vue&type=style&index=0&id=cabfe25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabfe25a",
  null
  
)

export default component.exports